import { ofType } from 'redux-observable';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import AuthService from '@/features/auth/services/AuthService';
import {
  fetchOrganizations,
  fetchOrganizationsSuccess,
  fetchOrganizationsFailure,
} from './organizationsSlice';

// Epic to handle fetching organizations
export const fetchOrganizationsEpic = (action$: any) =>
  action$.pipe(
    ofType(fetchOrganizations.type),
    switchMap(() =>
      AuthService.getOrganizations().pipe(
        map((organizations) => fetchOrganizationsSuccess(organizations)),
        catchError((error) => 
          of(fetchOrganizationsFailure(error?.message || 'Failed to fetch organizations'))
        )
      )
    )
  );

// Export as array for combineEpics
export const organizationsEpics = [fetchOrganizationsEpic];

export default organizationsEpics;